// How you lost ground (`GameFacts.groundCause`, `groundPractice`): for a game
// whose middlegame went wrong (its middlegame result is Blown advantage or
// Behind, from `middlegame-result.ts`, which runs first), the cause that cost
// the reader the most win chance over the whole middlegame and the move to
// practise for it. The rule is `@chess/api-mistakes`' `lostGroundCause`; the
// moves are the reader's middlegame blunders and misses the review lists
// (`mistakes.ts`, which runs first), each with the classifier's pattern and
// the clock after it.
import type { GameFacts } from '@chess/api-model';
import { lostGroundCause, patternOf, type GroundMove } from '@chess/api-mistakes';
import type { FactExtractor, ScannedGame } from '../extractor.ts';

export const groundCause: FactExtractor = {
  id: 'ground-cause',
  extract(game: ScannedGame, facts: GameFacts): void {
    if (facts.middlegameResult !== 'blown' && facts.middlegameResult !== 'behind') return;
    const moves: GroundMove[] = (facts.mistakes ?? [])
      .filter((m) => m.stage === 'middlegame')
      .map((m) => ({
        ply: m.ply,
        san: m.san,
        kind: m.kind,
        before: m.before,
        after: m.after,
        pattern: patternOf(m, game.reader).pattern,
        clockSeconds: game.clockAfter(m.ply),
      }));
    const found = lostGroundCause(moves, game.reader, game.rules.winningPawns);
    if (!found) return;
    facts.groundCause = found.cause;
    facts.groundPractice = found.practice;
  },
};
